<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>이용약관</div>
    </div>
    <div class="card-body top">
      <div class="content">{{ service }}</div>
    </div>
  </div>
</div>
